var render = function render(){var _vm=this,_c=_vm._self._c;return _c('st-side-page',{staticClass:"cashier-page"},[_c('template',{slot:"side"},[_c('ul',{staticClass:"menu"},_vm._l((_vm.menus),function(menu,i){return _c('li',{key:i,staticClass:"menu-item"},[_c('router-link',{attrs:{"to":menu.path}},[_vm._v(_vm._s(menu.label))]),_c('fa-icon',{attrs:{"icon":['fal', 'chevron-right']}})],1)}),0)]),_c('router-view')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }